import React, { useEffect, useState } from 'react'
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import { get_employee_schedule_with_pagination, get_schedule_by_id, get_schedule_with_pagination, handle_schedule_update, query_replay_by_query_id, query_submit_by_id, query_view_by_id, schedule_cancel_by_id, schedule_creation, schedule_mobilize_by_id, schedule_update } from '../../../../config/Worksite/scheduleApis'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import { useDispatch, useSelector } from 'react-redux'
import { hasPrivilege } from '../../../../utils/privileges'
import Loader from '../../../../Components/Loader/Loader'
import { getUserData } from '../../../../utils/localStorage'
import { Icons } from '../../../../utils/GlobalIcons'
import { useLocation, useNavigate } from 'react-router-dom'
import { getActionColors, getStatusColors } from '../../../../utils/constants'
import CustomTooltipWithoutRoundBorder from '../../../../Components/CustomActionButtonWithTooltip/CustomTooltipWithoutRoundBorder'
import MyScheduleSearchFilter from '../MyScheduleSearchFilter/MyScheduleSearchFilter'
import AddQueryToSchedule from '../../Schedule/Components/AddQueryToSchedule/AddQueryToSchedule'
import ViewQueryModal from '../../Schedule/Components/ViewQuerySchedule/ViewQueryModal'
import MobilizeStartConfirmationView from '../../Schedule/Components/MobilizeStartConfirmationView/MobilizeStartConfirmationView'
import ActionHistory from '../../../../Components/ActionHistory/ActionHistory'
import CustomConfirmationView from '../../../../Components/CustomConfirmationView/CustomConfirmationView'
import CustomLegend from '../../../../Components/custom_components/CustomLegend/CustomLegend'
import { fetchHistoryData } from '../../../../config/HistoryService/historyService'

function MyScheduleTable() {
    const navigate = useNavigate()
    const privileges = useSelector((state) => state.privileges.privileges);

    const myScheduleFilter = useSelector(state => state.myScheduleFilter.myScheduleFilter);

    // State variables for managing schedule data, pagination, and modal states
    const [scheduleListing, setScheduleListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });
    const [refresh, setRefresh] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({ isOpen: false, id: '', formValues: {} });

    const [isLoading, setIsLoading] = useState(false); // Loader state

    const [openQueryModal, setOpenQueryModal] = useState({
        isOpen: false,
        id: '',
    });
    const [viewQueryModal, setViewQueryModal] = useState({
        isOpen: false,
        info: {},
    });
    const [mobilizeModal, setMobilizeModal] = useState({
        isOpen: false,
        id: null,
        Values: null,
    });


    const [showHistory, setShowHistory] = useState(false); // history modal state
    const [historyData, setHistoryData] = useState([]);
    const [historyLoader, setHistoryLoader] = useState(false); // Loader state


    const [isScheduleActionModal, setIsScheduleActionModal] = useState({
        isOpen: false,
        id: null,
        values: null,
    });

    const [selectedAction, setSelectedAction] = useState(null);

    // Fetch schedule data on page change or refresh
    useEffect(() => {
        fetchSchedules();
    }, [pageNumber, totalItemPerPage, myScheduleFilter, refresh]);

    // Fetch schedule data from API
    const fetchSchedules = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        Object.keys(myScheduleFilter).forEach(key => formData.append(key, myScheduleFilter[key]));

        try {
            setIsLoading(true)
            const response = await get_employee_schedule_with_pagination(formData);
            if (response?.status === "success") {
                const data = response.data;
                setScheduleListing(data.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setScheduleListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };


    // Define the required permission actions
    const PERMISSION_ACTIONS = {
        view: 4,
        edit: 5,
        history: 6,
        add: 3,
        Cancel: 17,
        addReport: 9,
        ViewReport: 12,
    };

    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.view),
        edit: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.edit),
        history: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.history),
        add: false,// hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.add),
        cancelSchedule: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.Cancel),
        addReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.addReport),
        ViewReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.ViewReport),

    };

    // / Function to check if any action-related permissions are granted
    const hasActionPermissions = userPermissions.view || userPermissions.edit || userPermissions.history;

    //  if TRUE "Cancelled" filter is applied
    const isCancelledFilterApplied = myScheduleFilter?.Iscancel === 1;

    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Schedule Code", key: "SD_ScheduleCode" },
        { title: "Project", key: "project" },
        { title: "Main site", key: "mainSite" },
        { title: "Worksite", key: "WD_WorksiteName" },
        { title: "Technology", key: "SD_Technology" },
        { title: "Survey from", key: "SD_Survey_from_date" },
        { title: "Survey to", key: "SD_Survey_end_date" },

        {
            title: "Current Progress",
            key: "CurrentProgress",
            render: (text, record) => (
                <span style={{ color: getActionColors(record.Shedule_process_status).color }}>
                    {isCancelledFilterApplied == 1 ? "" : record.CurrentProgress}
                </span>
            ),
        },
        {
            title: "Status",
            key: "SD_Status",
            render: (text, record) => {
                const style = getStatusColors(record.Status_Id);
                return (

                    <span className="status-badge" style={style}>
                        {record?.SD_Status}
                    </span>
                );
            },
        },
        { title: "Actions", key: "actions", render: (text, row) => renderActions(row) },
    ] //  Filter out “Current Progress and Status when cancelled filter applied || removes the "Actions" column when hasActionPermissions is false
        .filter(
            (column) =>
                (column.key !== "CurrentProgress" || !isCancelledFilterApplied == 1) &&
                (column.key !== "SD_Status" || !isCancelledFilterApplied == 1) &&
                (column.key !== "actions" || hasActionPermissions)
        );

    // Render action icons for each schedule item
    const renderActions = (row) => (

        <div className="action-container">
            {userPermissions.ViewReport &&
                <CustomTooltipWithoutRoundBorder title="Reports">
                    <Icons.ViewReport className="view-action-icon" onClick={() => handleNavigateToBin(row?.id)} />
                </CustomTooltipWithoutRoundBorder>
            }

            {/* Shedule_process_status =0 MEANS SCHEDULE NOT STARTED */}
            {row?.ScheduleAcceptorNot == 1 && row?.is_cancel != 1 && (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {/*  START */}
                    {row?.Shedule_process_status == 0 && (
                        <CustomTooltipWithoutRoundBorder title="Start">
                            <Icons.Start
                                className="view-action-icon"
                                onClick={() => {
                                    setSelectedAction('start');
                                    openScheduleActionModal(row?.id, row)
                                }}
                            />
                        </CustomTooltipWithoutRoundBorder>
                    )}

                    {/*  HOLD  */}
                    {(row?.Shedule_process_status == 1 || row?.Shedule_process_status == 4) && (
                        <CustomTooltipWithoutRoundBorder title="Hold">
                            <Icons.Pause
                                className="hold-action-icon"
                                onClick={() => {
                                    setSelectedAction('hold');
                                    openScheduleActionModal(row?.id, row)
                                }}
                            />
                        </CustomTooltipWithoutRoundBorder>
                    )}

                    {/*  COMPLETE */}
                    {(row?.Shedule_process_status == 1 || row?.Shedule_process_status == 4) && (
                        <CustomTooltipWithoutRoundBorder title="Complete">
                            <Icons.Complete
                                className="complete-action-icon"
                                onClick={() => {
                                    setSelectedAction('complete');
                                    openScheduleActionModal(row?.id, row)
                                }}
                            />
                        </CustomTooltipWithoutRoundBorder>
                    )}

                    {/*  RESUME  */}
                    {row?.Shedule_process_status == 3 && (
                        <CustomTooltipWithoutRoundBorder title="Resume">
                            <Icons.Resume
                                className="resume-action-icon"
                                onClick={() => {
                                    setSelectedAction('resume');
                                    openScheduleActionModal(row?.id, row)
                                }}
                            />
                        </CustomTooltipWithoutRoundBorder>
                    )}


                </div>

            )}

            {userPermissions.history &&
                <CustomTooltipWithoutRoundBorder title="History">
                    <Icons.History className="history-action-icon" onClick={() => handleHistoryModal(true, row?.id)} />
                </CustomTooltipWithoutRoundBorder>}

            {/* {userPermissions?.view && (
                <CustomTooltipWithoutRoundBorder title="View ">
                    <Icons.View className="view-action-icon" onClick={() => ScheduleViewNavigate(row?.id)} />
                </CustomTooltipWithoutRoundBorder>
            )} */}
            {/* CANCELD  AND HAVE EDIT PRIVILEGE */}
            {/* {row?.is_Schedule_Cancled == 0 && userPermissions?.edit && Number(row?.Shedule_process_status) !== 2 && ( //2MEANS COMPLETED
                <CustomTooltipWithoutRoundBorder title="Edit ">
                    <Icons.Edit className="edit-action-icon" onClick={() => handleModal(true, row?.id)} />
                </CustomTooltipWithoutRoundBorder>
            )} */}

            {/* {row?.is_Schedule_Cancled == 0 && Number(row?.is_mobilize) === 0 && Number(row?.Status_Id) === 1 && (
                <CustomTooltipWithoutRoundBorder title="Mobilize">
                    <Icons.Mobilize
                        className="mobilize-action-icon"
                        onClick={() => handleMobilizeModal(true, row?.id, row)}
                    />
                </CustomTooltipWithoutRoundBorder>
            )} */}
            {/* {(row?.Is_query_sended && row?.Is_query_assigned_by) ? (
                <CustomTooltipWithoutRoundBorder title="View Query">
                    <Icons.Comment
                        // QueryReply
                        className="comment-action-icon"
                        onClick={() => handleOpenQueryModal(true, row?.id)}
                    />
                </CustomTooltipWithoutRoundBorder>
            ) : userData?.RoleId === 4 && !row?.Is_query_sended ? ( //already sent query then hide the add query icon
                <CustomTooltipWithoutRoundBorder title="Raise Query">
                    <Icons.Query
                        className="comment-action-icon"
                        onClick={() => handleOpenQueryModal(true, row?.id, 'add')}
                    />
                </CustomTooltipWithoutRoundBorder>
            ) : null}


            {Number(row?.Shedule_process_status) !== 2 && row?.is_Schedule_Cancled == 0 && userPermissions.cancelSchedule && ( //HIDE CANCEL ICON WHEN SCHEDULE IS CANCEL
                <CustomTooltipWithoutRoundBorder title="Cancel Schedule">
                    <Icons.Cancel
                        className="cancel-action-icon"
                        onClick={() => openCancelSchedule(row?.id, row)}
                    />
                </CustomTooltipWithoutRoundBorder>
            )} */}
        </div>
    );

    // Map the schedule data into table rows
    const rows = () => scheduleListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.SD_id,
        SD_ScheduleCode: item.SD_ScheduleCode,
        SD_Status: item?.status?.StatusName,
        Status_Id: item?.status?.SL_ID,
        SD_Survey_from_date: item.SD_Survey_from_date,
        SD_Survey_end_date: item?.SD_Survey_end_date,
        SD_Technology: item.technology?.TechnologiesTypeName,
        Is_query_sended: item?.Is_query_sended,
        Is_query_assigned_by: item?.Is_query_assigned_by,
        WD_WorksiteName: item?.worksite?.WD_WorksiteName || '',
        project: item?.projectName || '',
        is_mobilize: item?.is_mobilize || 0,
        mainSite: item?.mainSite,
        CurrentProgress: item?.Is_completed,
        Shedule_process_status: item?.Shedule_process_status,
        is_Schedule_Cancled: item?.is_cancel || 0,
        is_Invoice_Paid: item?.allInvoicesPaid || false,
        ScheduleAcceptorNot: item?.ScheduleAcceptorNot || 0,
        is_urgent: item?.is_urgent == 1 ? true : false,
        isReportAdd: !item?.is_cancel == 1 && //FOR REPORT ADD BUTTON SHOWS CONDITION
            item?.Shedule_process_status !== 0 &&
            item?.status?.SL_ID == 1,


    }));


    const ScheduleViewNavigate = (scheduleId) => {
        navigate(`/worksites/schedule/${scheduleId}`)
    }
    const handleNavigateToBin = (scheduleId) => {
        navigate(`/worksites/schedule/${scheduleId}/bin-report/list`)
    }
    // Open Add/Edit/View modal
    const handleModal = async (isOpen, scheduleID, actionType) => {
        if (actionType === 'view' && scheduleID) { //FOR VIEW
            await fetchScheduleDetails(scheduleID,);
            setIsViewModalOpen(true);
        } else if (scheduleID) { //FOR EDIT
            await fetchScheduleDetails(scheduleID);
        } else { //FOR ADD
            setModalProps({
                isOpen,
                id: '',
                formValues: {
                    SD_ScheduleCode: '',
                    SD_Survey_from_date: '',
                    SD_Survey_end_date: '',
                    SD_TechnologyId: '',
                    SD_FrequencyId: '',
                    SD_ScheduleDescription: '',
                    employee_ids: [],
                    equipment_ids: [],
                    SD_Status: 1,
                    SD_WorksiteId: ''
                }
            });
        }

    };

    // Fetch details of a specific schedule item
    const fetchScheduleDetails = async (scheduleID, actionType) => {
        try {
            const response = await get_schedule_by_id({ scheduleID });
            if (response?.status === "success") {
                const data = response?.data;

                let employeeArr = [] //FOR SAVE THE WORKFORCE ID IN A ARRAY
                employeeArr = data?.schedule_employee?.map((item) => item?.SEMP_EmployeeID);

                let equipmentsArr = [] //FOR SAVE THE EQUIPMENT ID IN A ARRAY
                equipmentsArr = data?.schedule_equipment?.map((item) => item?.SEM_EquipmentID);

                setModalProps({
                    isOpen: actionType === 'view' ? false : true,
                    id: data?.SD_id,
                    formValues: {
                        SD_ScheduleCode: data?.SD_ScheduleCode,
                        SD_TechnologyId: data?.SD_TechnologyId,
                        SD_FrequencyId: data?.SD_FrequencyId,
                        SD_ScheduleDescription: data?.SD_ScheduleDescription,

                        SD_Survey_from_date: data?.SD_Survey_from_date,
                        SD_Survey_end_date: data?.SD_Survey_end_date,

                        SD_WorksiteId: data?.SD_WorksiteId,
                        employee_ids: employeeArr,
                        equipment_ids: equipmentsArr,
                        SD_Status: data?.SD_Status,
                    },
                });
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }
    };

    // Handle saving schedule data (add/edit)
    const handleScheduleSave = async (values, scheduleId) => {
        try {
            setIsButtonDisabled(true);
            const apiFunction = scheduleId ? schedule_update : schedule_creation;
            if (scheduleId) values.ScheduleID = scheduleId;

            const response = await apiFunction(values);
            const message = response?.data?.message || 'Something went wrong!';
            if (response?.data?.status === "success") {
                SuccessToast(message);
                closeModal();
                setRefresh(!refresh);
            } else {
                ErrorToast(message);
            }
        } catch (error) {
            const errorMessage = error?.data?.errors ? Object.values(error.data.errors)[0][0] : 'Something went wrong!';
            ErrorToast(errorMessage);
            console.log("errorMessage", errorMessage);

        } finally {
            setIsButtonDisabled(false);
        }
    };

    // Close modal
    const closeModal = () => {
        setModalProps({ ...modalProps, isOpen: false });
        setIsViewModalOpen(false);
    };

    // FOR CLSOE THE QUERY MODAL
    const closeQueryModal = () => {
        setOpenQueryModal({ isOpen: false, id: '' });
    };
    // FOR CLSOE THE VIEW QUERY MODAL
    const closeViewQueryModal = () => {
        setViewQueryModal({ isOpen: false, info: '' });
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    const handleMobilizeModal = (isOpen, id, Values) => {
        setMobilizeModal({
            isOpen: isOpen,
            id,
            Values,
        });
    };

    // --------------------------HANDLE SCHEDULE STATUS ACTIONS START----------------
    const openScheduleActionModal = (id, values) => {
        setIsScheduleActionModal({
            isOpen: true,
            id,
            values,
        });
    };

    const closeScheduleActionModal = () => {
        setSelectedAction(null);
        setIsScheduleActionModal({
            isOpen: false,
            id: null,
            values: null,
        });

    }
    //------------------------------ HANDLE SCHEDULE STATUS ACTIONS END----------

    // Function to handle HIDE/SHOW query add MODAL
    const handleOpenQueryModal = (isOpen, id = '', type) => {

        if (type === `add`) { //show add query form
            setOpenQueryModal({ isOpen, id })
        } else { //show the query info
            fetchQueryDetails(id)
        }
    }

    // QUERY SUBMIT
    const handleQuerySubmit = async (values) => {
        try {
            setIsButtonDisabled(true);
            const response = await query_submit_by_id(values);
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message);
                setOpenQueryModal({ isOpen: false, id: '' });
                setRefresh(!refresh);
            } else {
                ErrorToast(response?.data?.message || "Something went wrong!");
            }
        } catch (error) {
            console.error("Error saving project:", error);
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // QUERY REEPLAY SUBMIT
    const handleQueryReplaySubmit = async (values, queryId) => {

        try {
            setIsButtonDisabled(true);
            const response = await query_replay_by_query_id(queryId, {
                reply_text: values.reply_text,
            });
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message);
                closeViewQueryModal()
                setRefresh(!refresh);
            } else {
                ErrorToast(response?.data?.message || "Something went wrong!");
            }
        } catch (error) {
            console.error("Error saving project:", error);
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // Fetch details of a query
    const fetchQueryDetails = async (scheduleID) => {
        try {
            setIsLoading(true)
            const response = await query_view_by_id({ scheduleID });
            if (response?.data?.status === "success") {
                const data = response?.data?.data;
                setViewQueryModal({ isOpen: true, info: data })
            } else {
                ErrorToast(response?.message);
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsLoading(false)
        }
    };

    // FOR HANDLE START SCHEDULE
    const handleStartSchedule = async (scheduleID) => {
        try {
            setIsButtonDisabled(true);
            const response = await schedule_mobilize_by_id({ scheduleID });

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                handleMobilizeModal(false, "", "")
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message, true, response?.data);
                // ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };


    // // FOR HANDLE CANCEL SCHEDULE
    // const handleCancelSchedule = async (ScheduleID) => {
    //     try {
    //         setIsButtonDisabled(true);
    //         const params = {
    //             is_cancel: 1, //(1 is cancel and 0 is defult )
    //             ScheduleID: ScheduleID
    //         }
    //         const response = await schedule_cancel_by_id(params);

    //         if (response?.status === "success") {
    //             setRefresh(prev => !prev); // Refresh table
    //             closeCancelSchedule()
    //             SuccessToast(response?.message);
    //         } else {
    //             ErrorToast(response?.message, true, response?.data);
    //         }
    //     } catch (error) {
    //         ErrorToast('Something went wrong!');
    //     } finally {
    //         setIsButtonDisabled(false);
    //     }
    // };


    // Map action → status ID
    const getStatusIdByAction = (action) => {
        switch (action) {
            case "start":
                return 1;
            case "hold":
                return 3;
            case "resume":
                return 4;
            case "complete":
                return 2;
            default:
                return 0;
        }
    };


    // Confirm Action → Call API
    const handleScheduleActionConfirm = async () => {
        const statusId = getStatusIdByAction(selectedAction);

        const data = {
            ScheduleID: isScheduleActionModal?.id,
            Shedule_Status: statusId,
        };

        try {
            const response = await handle_schedule_update(data);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                SuccessToast(response?.message);
            } else {
                console.error("Action failed:", response?.message);
            }
        } catch (error) {
            console.error("Error updating schedule:", error);
        } finally {
            closeScheduleActionModal();
        }
    };


    // HISTORY BUTTON CLICK AND API CALL
    const handleHistoryModal = async (open, id) => {
        setShowHistory(open);

        if (open) {
            setHistoryLoader(true);
            try {
                const response = await fetchHistoryData('schedule', id);

                if (response?.status === "success") {

                    //  Transform API response for  table usage
                    const formatted = response?.data?.map((item, index) => ({
                        id: item.id,
                        schedule_name: item.scheduleCode || "-",
                        changedBy: item.changed_by_name || "Unknown",
                        changedAt: item.changed_at || "-",
                        changeDescription: item.change_description || "-",
                    }));

                    setHistoryData(formatted || []);
                } else {
                    // InfoToast("No history data found.");
                    setHistoryData([]);
                }
            } catch (error) {
                console.error("Error fetching project history:", error);
            } finally {
                setHistoryLoader(false);
            }
        } else {
            setHistoryData([]);
        }
    };


    return (
        <>
            <div className='workforce-management-table-container'>
                <MyScheduleSearchFilter
                    tableTitle={`My Schedules`}
                    isAddEditModalOpen={modalProps.isOpen}
                    handleAddEditModal={handleModal}
                    isAddPermission={userPermissions?.add}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}

                />
                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                        <CustomLegend />
                    </div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        renderActions={renderActions}
                        isCheckbox={false}
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/* Custom Add query Modal */}
            {openQueryModal?.isOpen && <CustomModal
                open={openQueryModal?.isOpen}
                handleClose={closeQueryModal}
                title={"Add Query"}
                body={
                    <AddQueryToSchedule
                        isButtonDisabled={isButtonDisabled}
                        scheduleInfo={openQueryModal}
                        handleSave={handleQuerySubmit}

                    />
                }
                maxWidth="700px"
            />}


            {/* Custom View query Modal */}
            {viewQueryModal?.isOpen && <CustomModal
                open={viewQueryModal?.isOpen}
                handleClose={closeViewQueryModal}
                title={"View Query"}
                body={

                    <ViewQueryModal
                        isButtonDisabled={isButtonDisabled}
                        queryInfo={viewQueryModal?.info}
                        handleSave={handleQueryReplaySubmit}
                    />
                }
                maxWidth="700px"
            />}


            {/* MOBILIZE ACTION MODAL */}
            {mobilizeModal?.isOpen && <CustomModal
                open={mobilizeModal?.isOpen}
                handleClose={() => handleMobilizeModal(false, "")}
                title="Mobilize Schedule"
                body={
                    <MobilizeStartConfirmationView
                        scheduleName={mobilizeModal?.Values?.SD_ScheduleCode || `N/A`}
                        isButtonDisabled={isButtonDisabled}
                        onConfirm={() => handleStartSchedule(mobilizeModal?.id)}
                        onCancel={() => handleMobilizeModal(false, "")}
                    />
                }
                maxWidth="600px"
            />}

            {/* CANCEL SCHEDULE */}
            {/* {cancelSchedule.isOpen &&
                <CustomConfirmModal
                    custom_text={`Do you want to cancel the schedule ${cancelSchedule?.values?.SD_ScheduleCode || "N/A"}`}
                    open_modal={cancelSchedule.isOpen}
                    close_modal={closeCancelSchedule}
                    confirm_function={() => handleCancelSchedule(cancelSchedule.id)}
                />} */}


            {/* HISTORY VIEW MODAL */}
            {showHistory && <CustomModal
                open={showHistory}
                handleClose={() => handleHistoryModal(false)}
                title="Schedule History"
                maxWidth="75%"
                body={
                    historyLoader ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <Loader />
                        </div>
                    ) : (
                        <ActionHistory
                            title=""
                            data={historyData}
                            columns={[
                                { key: "schedule_name", label: "Schedule" },
                                { key: "changedBy", label: "Changed By" },
                                { key: "changedAt", label: "Changed At" },
                                { key: "changeDescription", label: "Change Description" },
                            ]}
                            noDataMessage="No change history available."
                        />

                    )
                }
            />}


            {/*  Confirmation Modal */}
            {isScheduleActionModal.isOpen && (
                <CustomModal
                    open={isScheduleActionModal.isOpen}
                    title={
                        selectedAction === "start"
                            ? "Start Schedule"
                            : selectedAction === "hold"
                                ? "Hold Schedule"
                                : selectedAction === "resume"
                                    ? "Resume Schedule"
                                    : selectedAction === "complete"
                                        ? "Complete Schedule"
                                        : "Confirm Action"
                    }
                    handleClose={closeScheduleActionModal}
                    body={
                        <CustomConfirmationView
                            message={`Are you sure you want to ${selectedAction === "start"
                                ? "Start"
                                : selectedAction === "hold"
                                    ? "Hold"
                                    : selectedAction === "resume"
                                        ? "Resume"
                                        : selectedAction === "complete"
                                            ? "Complete"
                                            : ""
                                } this schedule?`}
                            onConfirm={handleScheduleActionConfirm}
                            onCancel={closeScheduleActionModal}
                            confirmLabel={
                                selectedAction === "start"
                                    ? "Start"
                                    : selectedAction === "hold"
                                        ? "Hold"
                                        : selectedAction === "resume"
                                            ? "Resume"
                                            : selectedAction === "complete"
                                                ? "Complete"
                                                : "Confirm"
                            }
                            cancelLabel="Back"
                        />
                    }
                    maxWidth="500px"
                />
            )}

        </>
    )
}

export default MyScheduleTable